export default {
  name: "pro-enc-input-edit",
  props: {
    value: {
      type: String,
      default() {
        return "";
      }
    },
    rangeId: {
      type: String,
      default() {
        return "";
      }
    }
  },
  methods: {
    onInput(val) {
      this.$emit("onChange", val);
    }
  }
};